// import { createUUID } from "./setUUID.js";
import qs from "qs";
const url = qs.parse(window.location.search.slice(1));

export const setUUID = function () {
    //清除老的UUID
    if (localStorage.getItem("KEY_UUID")) {
        localStorage.removeItem("KEY_UUID")
    }
    let uuidData = localStorage.getItem("PAGE_EDITOR_KEY_UUID");
    let isMyActivity = false;//是否是自己的活动
    if (uuidData) {
        uuidData = JSON.parse(uuidData);
        if (!uuidData[url.activityId]) {
            uuidData[url.activityId] = {
                UUID_LIST: []
            };
        }
    } else {
        
        uuidData = {
            UUID_MINE: `${createUUID()}-${url.activityId}`,
        };
        uuidData[url.activityId] = {
            UUID_LIST: []
        };
    }
    //判断url是否有uuid
    if (url.uuid) {

        if (uuidData.UUID_MINE != url.uuid) {
            //判断uuid不是自己的,就去看缓存里面是否有保存,有的话就说明看过这个活动,不增加转发
            uuidData[url.activityId].UUID_LIST.map(item => {
                if (item == url.uuid) {
                    isMyActivity = true;
                }
            });
        } else {
            //自己的活动不增加转发
            isMyActivity = true;
        }
    }else{
        isMyActivity = true;
    }
    if (!isMyActivity && url.uuid) {
        uuidData[url.activityId].UUID_LIST.push(url.uuid);
    }
    //把uuid数据保存在本地
    localStorage.setItem("PAGE_EDITOR_KEY_UUID", JSON.stringify(uuidData));
    return {
        UUID_MINE: uuidData.UUID_MINE,
        isMyActivity: isMyActivity
    };



}
//创建uuid
export const createUUID = function () {
    let s = [];
    let hexDigits = "0123456789abcdef";
    for (let i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
    }
    s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = "-";

    let uuid = s.join("");
    return uuid;
}